import React from 'react'

import InputItemWrapper from "./InputItemWrapper"
import SimpleDropdown from './SimpleDropdown'

const LabeledSimpleDropdown = ({
  id = null,
  label = null,
  type = "text",
  placeholder = null,
  disabled = false,
  error = false,
  errorPosition,
  autoComplete = "off",
  noBorderOnFocus = false,
  ...props
}) => (
  <InputItemWrapper id={label} label={label} error={error} errorPosition={errorPosition}>
    <SimpleDropdown
      id={id || label}
      name={id}
      type={type}
      placeholder={placeholder}
      error={!!error}
      disabled={disabled}
      noBorderOnFocus={noBorderOnFocus}
      autoComplete={autoComplete}
      blurInputOnSelect
      {...props}
    />
  </InputItemWrapper>
)

export default LabeledSimpleDropdown
